import React, { useRef, useState } from "react";
import DatePicker from "react-date-picker";
import styled from "styled-components";
import "react-date-picker/dist/DatePicker.css";
import "react-calendar/dist/Calendar.css";
import { ReactComponent as CalendarIcon } from "../../Assets/icons/calendarIcon.svg";
import { useTranslate, useTolgee } from '@tolgee/react';
const MeetingDateTimePicker = ({
    id,
    value,
    setValue,
    format,
    slim,
    onboardStyle,
    noCalendar,
    disabled = false,
    maxDate,
}) => {

    const normalizeDate = (val) => {
        if (val instanceof Date && !isNaN(val)) return val;
        const parsed = val ? new Date(val) : null;
        return parsed && !isNaN(parsed) ? parsed : null;
    };

    const getTodayStart = () => {
        const todayStart = new Date();
        todayStart.setHours(0, 0, 0, 0);
        return todayStart;
    };

    const handleChange = (nextVal) => {
        const safeDate = normalizeDate(nextVal);
        if (!safeDate || disabled) return;
        const todayStart = getTodayStart();
        if (safeDate < todayStart) return;
        const now = new Date();
        if (safeDate.toDateString() === now.toDateString() && safeDate.getTime() < now.getTime()) {
            const adjustedDate = new Date(safeDate);
            adjustedDate.setHours(
                now.getHours(),
                now.getMinutes(),
                now.getSeconds(),
                now.getMilliseconds()
            );
            setValue(adjustedDate);
            return;
        }
        setValue(safeDate);
    };

    const handleCLick = () => {
        if (disabled) return;
        setIsMenuOpen(!menuOpen);
    };
    const [menuOpen, setIsMenuOpen] = useState(false);
    const { t } = useTranslate();
    const tolgee = useTolgee();
    const currentLocale = tolgee.getLanguage();
    return (
        <Container slim={slim}>
            <DatePicker
                id={id}
                value={normalizeDate(value)}
                onChange={disabled ? undefined : handleChange}
                clearIcon={null}
                isOpen={disabled ? false : menuOpen}
                openCalendarOnFocus={!disabled}
                minDate={getTodayStart()}
                maxDate={maxDate}
                calendarIcon={noCalendar ? null : <CalendarIcon />}
                locale={currentLocale.split("-")[0]}
                inputProps={disabled ? { readOnly: true, tabIndex: -1 } : {}}
            >
            </DatePicker>

            {!value &&
                <PlaceHolderWrapper onClick={() => !disabled && handleCLick()} onboardStyle={onboardStyle}>
                <p>{t('new_chat.select_date')}</p>
                </PlaceHolderWrapper>
            }
            {disabled && <InteractionBlocker aria-hidden="true" />}

        </Container >
    );
};

export default MeetingDateTimePicker;
const Container = styled.div`
background:${({ theme }) => theme.menu.enterPhoneNumberBackground};
border-radius:4px;
min-width:120px;
padding:5px;
display:flex;
justify-content:center;
position:relative;



.react-date-picker{
    width:100%;
    color:${({ theme }) => theme.menu.primaryTextColor};
    
  }

  .react-date-picker__wrapper {
    width: 100%;
    border: none;
    padding: ${props => props.slim ? "0" : "14px 16px "};
        color:${({ theme }) => theme.menu.primaryTextColor};
    border-radius: 10px;
    
  }
  .react-date-picker react-date-picker--closed react-date-picker--enabled{
    width:100%;
  }

  .react-date-picker__inputGroup__input:focus{
    outline:none;
    background:${({ theme }) => theme.menu.groupContentBackground};
    border-radius:4px;
  }


  .react-calendar{
    background: ${({ theme }) => theme.menu.enterPhoneNumberBackground};
       border:1px solid ${({ theme }) => theme.sidebar.borderColor};
       border-radius:12px;
       padding:8px;
       box-shadow: 0 16px 40px rgba(0, 0, 0, 0.5);
   }

.react-calendar__month-view__weekdays__weekday abbr{
    text-decoration:none;
    font-weight:600;
}

.react-calendar__tile{
    border-radius:10px;
    padding:10px 6px;
    margin:1px 0;

}

.react-calendar__month-view__days__day{
    color:${({ theme }) => theme.menu.primaryTextColor};
    aspect-ratio:1;
    display:flex;
    align-items:center;
    justify-content:center;
    padding:0;
    margin:1px auto;
    border-radius:50%;
}
.react-calendar__month-view__days__day--weekend{
    color:${({ theme }) => theme.menu.secondaryTextColor};
}
.react-calendar__month-view__days__day--neighboringMonth{
    color:${({ theme }) => theme.menu.secondaryTextColor};
    opacity:0.4;
}

.react-calendar__tile--active{
background:${({ theme }) => theme.menu.selectedTextColor};

}
.react-calendar__navigation{
    margin-bottom:8px;
}
.react-calendar__navigation button{
    color:${({ theme }) => theme.menu.selectedTextColor};
    border-radius:8px;

}
.react-calendar__navigation__label{
    font-weight:700;
    font-size:14px;
}
.react-calendar__navigation button:enabled:hover, .react-calendar__navigation button:enabled:focus{
  background: ${({ theme }) => theme.menu.groupContentBackground};

}

.react-calendar__tile:enabled:hover, .react-calendar__tile:enabled:focus{
    background:${({ theme }) => theme.menu.groupContentBackground};
    color:${({ theme }) => theme.menu.selectedTextColor};
}
.react-calendar__year-view__months__month{
    color:${({ theme }) => theme.menu.primaryTextColor};
}
.react-calendar__tile--hasActive{
    background:${({ theme }) => theme.menu.selectedTextColor};

}
.react-date-picker__button svg{
    stroke:${({ theme }) => theme.menu.selectedTextColor};
}
.react-calendar__tile--now {
    background:${({ theme }) => theme.menu.avatarBackground};
}
.react-calendar__century-view__decades__decade{
      color:${({ theme }) => theme.menu.primaryTextColor};
}
.react-calendar__decade-view__years__year{
     color:${({ theme }) => theme.menu.primaryTextColor};
 }

.react-calendar__tile:disabled {
    opacity:0.3;
    background-color:transparent;
}
.react-calendar__navigation button:disabled{
    opacity:0.3;
    background-color:unset;
}

`;

const PlaceHolderWrapper = styled.div`
display:flex;
position:absolute;
background:${({ theme }) => theme.menu.enterPhoneNumberBackground};
top:0;
bottom:0;
align-items:center;
border-radius:10px;
padding:${props => props.onboardStyle ? "0 16px" : 0};
p{
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
    color: ${({ theme }) => theme.menu.primaryTextColor};
}
`

const InteractionBlocker = styled.div`
position:absolute;
inset:0;
cursor:not-allowed;
`;
